import React, { useState, useEffect } from 'react';
import '@expo/match-media'
import { useMediaQuery } from "react-responsive";

import { Platform } from 'react-native';
import { Overlay } from 'react-native-elements';
import Table from '../results-table'
import Buttons from '../results-buttons'
import Predictor from '../predictor'
import Page from './page'
import Stats from '../stats'
import WinLoss from '../graph'
import OverlayWeb from '../web/Overlay';
import Settings from '../settings'
import SASettings from '../sa-setting'
import SexySettings from '../sexy-setting'
import logo from '../../images/minilogo.png'
import moment from 'moment'

const noPackage = (pname, pexpire) => {
  switch(pname.toUpperCase()) {
      case '': case null: case 'NONE':
      return true;
  }

  if (!pexpire) {
    throw new Error('No package expire date')
  }

  return moment(pexpire).isBefore(moment())
}

export default ({ onChooseGame, vendor, subscription, subscription_expire }) => {

    const vip = !noPackage(subscription, subscription_expire);

    const [popup, setPopup] = useState(true);
    const [popupRoom, setPopupRoom] = useState(vip && vendor.match(/sa|sexy/) ? true : false);

    const isMobileDevice = useMediaQuery({
        query: "(max-width: 720px)"
    });

    const Overlayer = Platform.OS === 'web' ? OverlayWeb : Overlay;
    let RoomSettings = null;
    switch(vendor) {
        case 'sa': RoomSettings = SASettings; break;
        case 'sexy': RoomSettings = SexySettings; break;
    }

    return <Page 
        onSetting={() => { setPopup( true ) }}
        onToggleRoom={() => { setPopupRoom( true ) }}
        logo={logo}
        title={`สูตรบาคาร่า`}
        subtitle={vendor.toUpperCase()}
        onClickLogo={onChooseGame}
    >
        <Table small={isMobileDevice} />
        <Predictor/>
        <Stats />
        <Buttons
            vendor={vendor}
            planChangeClick={() => { setPopup( true ) }} 
            toggleSAClick={() => { setPopupRoom( true ) }}
        />
        <WinLoss />
        <Overlayer
            key='overlay'
            isVisible={popup}
            windowBackgroundColor="rgba(0, 0, 0, .5)"
            onBackdropPress={() => {}}
            overlayBackgroundColor="#ffffff"
            // overlayStyle={{backgroundColor: '#ffffff', borderRadius: 10}}
        >
            <Settings close={() => setPopup(false)} openSA={() => { setPopup(false); setPopupRoom( true ) }}/>
        </Overlayer>
        <Overlayer
            key='overlay-room'
            isVisible={popupRoom && RoomSettings}
            windowBackgroundColor="rgba(0, 0, 0, .5)"
            onBackdropPress={() => {}}
            overlayBackgroundColor="#ffffff"
            // overlayStyle={{backgroundColor: '#ffffff', borderRadius: 10}}
        >
            {RoomSettings && <RoomSettings close={() => setPopupRoom(false)} />}
        </Overlayer>
    </Page>
}

/*
        

*/

